import { Box } from '@mui/material';

const FormClientPage: React.FC<any> = ({ children }: { children: React.ReactNode }) => {
    return (
        <Box
            m={3}
            justifyContent="center"
            margin="auto"
            alignItems="center"
            boxShadow="10"
            borderRadius="1"
            width="60%"
            display="flex"
            flexDirection="column"
            pt={2}
            mt={2}
            mb={4}
        >
            {children}
        </Box>
    );
};

export default FormClientPage;
